import { axios } from '@Root/API'

export const putIncludeInHesa = payload => {
  return axios.put(`contact/include-in-hesa`, payload)
}
